/**
 * Created by slava on 02.02.17.
 */

const levels = {};

levels.User = function (isNewUser) {
    // a missing availables block would leave every gate open rather than closed, so it must be loud
    const availables = cleverapps.config.availables;
    if (cleverapps.config.debugMode && (!availables || Object.keys(availables).length === 0)) {
        throw new Error("No availables config");
    }

    cleverapps.User.call(this, isNewUser);

    connector.platform.on("userIdChanged", this.onUserIdChanged.bind(this));

    connector.player.on("changed", this.onUserInfoChanged.bind(this));
    cleverapps.settings.on("changedAvatar", this.onUserInfoChanged.bind(this));
    cleverapps.settings.on("changedNickname", this.onUserInfoChanged.bind(this));
};

levels.User.prototype = Object.create(cleverapps.User.prototype);
levels.User.prototype.constructor = levels.User;

levels.User.prototype.loadData = function (info) {
    cleverapps.User.prototype.loadData.call(this, info);

    this.currentPhysicalLevel = {
        episode: info.episode,
        level: info.level,
        progress: info.progress || 0
    };

    if (info.uniqueStartEvent) {
        this.uniqueStartEvent = info.uniqueStartEvent;
    }

    this.migrateEpisode();

    this.trigger("updateLeague", true);

    if (this.isPassedAllPhysicalLevels()) {
        cleverapps.playSession.logEventOnce(cleverapps.EVENTS.PASS_ALL_LEVELS);
    }
};

levels.User.prototype.isUniqueStart = function (episodeNo, levelNo, version) {
    const uniqueStartEvent = `${episodeNo}_${levelNo}_${version}`;

    if (this.uniqueStartEvent === uniqueStartEvent) {
        return false;
    }

    this.uniqueStartEvent = uniqueStartEvent;
    this.save(false);

    return true;
};

levels.User.prototype.getHumanReadableNumber = function () {
    return cleverapps.humanReadableNumber(this.currentPhysicalLevel.episode, this.currentPhysicalLevel.level);
};

levels.User.prototype.getVirtualLevel = function () {
    return this.getHumanReadableNumber() + this.currentPhysicalLevel.progress;
};

levels.User.prototype.checkAvailable = function (available, options) {
    available = available || {};
    options = options || [];

    const projectName = cleverapps.config.name;
    const source = connector.info.source;

    // most specific scope first: game-source, then game, subtype, source
    const scoped = `${projectName}-${source}`;
    if (available[scoped]) {
        return this.checkAvailable(available[scoped], options);
    }

    if (available[projectName]) {
        return this.checkAvailable(available[projectName], options);
    }

    if (cleverapps.config.subtype && available[cleverapps.config.subtype]) {
        return this.checkAvailable(available[cleverapps.config.subtype], options);
    }

    if (available[source]) {
        return this.checkAvailable(available[source], options);
    }

    if (available.registeredDate && this.registered < new Date(available.registeredDate).getTime()) {
        return false;
    }

    if (available.registeredBefore && this.registered >= new Date(available.registeredBefore).getTime()) {
        return false;
    }

    if (available.registered && this.registered + cleverapps.parseInterval(available.registered) > Date.now()) {
        return false;
    }

    if (available.disabled) {
        return false;
    }

    if (available.debugMode && !cleverapps.config.debugMode) {
        return false;
    }

    if (available.projectName) {
        available.projectName = cleverapps.toArray(available.projectName);
        if (available.projectName.indexOf(projectName) === -1) {
            return false;
        }
    }
    if (available.types && available.types.indexOf(cleverapps.config.type) === -1) {
        return false;
    }
    if (available.feature && (cleverapps.config.features || []).indexOf(available.feature) === -1) {
        return false;
    }
    if (available.source) {
        if (!Array.isArray(available.source)) {
            available.source = [available.source];
        }
        if (available.source.indexOf(source) === -1) {
            return false;
        }
    }

    if (available.language && cleverapps.settings.language !== available.language) {
        return false;
    }

    if (available.paymentsCountry && cleverapps.country.getCountry() !== available.paymentsCountry) {
        return false;
    }

    if (options.ignoreProgress) {
        return true;
    }

    if (available.location !== undefined && available.location !== null) {
        const location = cleverapps.meta.getSelectedLocation();
        return location && location.checkAvailable(available.location, options);
    }

    if (available.gameLevel !== undefined && available.gameLevel !== null) {
        return cleverapps.gameLevel && cleverapps.gameLevel.level >= available.gameLevel;
    }

    if (available.knockoutLevel !== undefined && available.knockoutLevel !== null) {
        return cleverapps.knockoutGame && cleverapps.knockoutGame.getLevel() >= available.knockoutLevel;
    }

    if (available.actualLevel !== undefined) {
        return this.getHumanReadableNumber() >= available.actualLevel;
    }

    if (available.actualLevelEqual !== undefined) {
        return this.getHumanReadableNumber() === available.actualLevelEqual;
    }

    return this.getLevel() + Math.min(1 - 1e-8, this.getExp() / this.getExpThreshold() + 1e-8) >= (available.level || 0);
};

levels.User.prototype.getLevel = function () {
    const episode = this.currentPhysicalLevel.episode;
    const level = this.currentPhysicalLevel.level;

    if (["merge", "merge2"].includes(cleverapps.config.type)) {
        return level;
    }

    let floatLevel = 2 * (episode + level / Level.LEVELS_PER_EPISODE);

    if (cleverapps.config.regime === "knockout") {
        floatLevel = 6 * (episode + level / Level.LEVELS_PER_EPISODE);
    }

    return Math.floor(floatLevel);
};

levels.User.prototype.getExp = function () {
    const episode = this.currentPhysicalLevel.episode;
    const level = this.currentPhysicalLevel.level;

    if (["merge", "merge2"].includes(cleverapps.config.type)) {
        return ExpHelper.GetMainInstance().getExp();
    }

    let floatLevel = 2 * (episode + level / Level.LEVELS_PER_EPISODE);

    if (cleverapps.config.regime === "knockout") {
        floatLevel = 6 * (episode + level / Level.LEVELS_PER_EPISODE);
    }

    return Math.round((floatLevel - Math.floor(floatLevel)) * Level.LEVELS_PER_EPISODE);
};

levels.User.prototype.getExpThreshold = function () {
    if (["merge", "merge2"].includes(cleverapps.config.type)) {
        return GameLevelHelper.GetMainInstance().nextLevelThreshold();
    }

    return Level.LEVELS_PER_EPISODE;
};

levels.User.prototype.isPassedAllPhysicalLevels = function () {
    const total = this.getEpisodesAmount();
    return total > 0 && this.currentPhysicalLevel.episode >= total;
};

levels.User.prototype.getFakeLevelsMission = function () {
    return cleverapps.missionManager.getRunningMissions().find((mission) => mission.logic && mission.logic.getCurrentLevel);
};

levels.User.prototype.isPlayingFakeLevels = function () {
    return this.isPassedAllPhysicalLevels() || this.getFakeLevelsMission();
};

levels.User.prototype.incPhysicalLevel = function () {
    if (this.isPlayingFakeLevels()) {
        this.currentPhysicalLevel.progress++;
    } else {
        this.currentPhysicalLevel.level++;
        if (this.currentPhysicalLevel.level === Level.LEVELS_PER_EPISODE) {
            this.currentPhysicalLevel.level = 0;
            this.incPhysicalEpisode();
        }
    }

    this.trigger("recheckAvailable");
    this.trigger("changePhysicalLevel");
    this.save();
};

levels.User.prototype.incPhysicalEpisode = function () {
    this.currentPhysicalLevel.episode++;
    this.save();

    cleverapps.metrics.logEvent(cleverapps.EVENTS.GENERAL.LEVEL_UP, {
        level: this.currentPhysicalLevel.episode
    });

    if (this.isPassedAllPhysicalLevels()) {
        cleverapps.playSession.logEventOnce(cleverapps.EVENTS.PASS_ALL_LEVELS);
    }

    const episode = this.currentPhysicalLevel.episode;

    connector.conversions.trackEvent(connector.EVENTS.CONVERSIONS.LEVEL_UP, {
        nickname: "d7a_level,d180a_level", level: episode
    });

    if ([1, 2, 3, 4, 5, 6, 7, 8, 10, 13, 15, 20, 22, 25, 30, 35, 40, 45, 50, 60, 70, 80, 90, 100].includes(episode)) {
        connector.conversions.trackEvent(connector.EVENTS.CONVERSIONS.LEVEL_REACH + episode, {
            nickname: `d180r_level_${episode},day180_reach_${episode},d7r_level_${episode},day7_reach_${episode}`
        });
    }

    if (episode === 1 && this.getDaysSinceRegistration() <= 3) {
        connector.conversions.trackEvent("d3r_level_1");
    }

    this.trigger("updateLeague");
};

levels.User.prototype.getFakeLevelsRange = function () {
    const firstEpisodeNo = cleverapps.config.type === "blocks" ? 1 : 5;
    const lastEpisodeNo = Math.min(levels.User.CalcEpisodesAmount(cleverapps.config.importMode), this.currentPhysicalLevel.episode);

    return { firstEpisodeNo, lastEpisodeNo };
};

levels.User.prototype.getRandomLevel = function (options = {}) {
    const seed = options.seed === undefined ? this.currentPhysicalLevel.progress : options.seed;

    const { firstEpisodeNo, lastEpisodeNo } = this.getFakeLevelsRange();

    const pseudo = PseudoRandom.GET("randomLevel");
    pseudo.seed(seed * 7237);

    // a tag key narrows the pick to the levels tagged so in the range, tag undefined means the untagged levels;
    // no tag key is any level; none matching in the range falls back to any level
    const tagged = "tag" in options ? Level.ListTagged(firstEpisodeNo, lastEpisodeNo, options.tag) : [];

    let number;
    if (tagged.length > 0) {
        number = tagged[pseudo.random(0, tagged.length - 1)];
    } else {
        const episodeNo = pseudo.random(firstEpisodeNo, lastEpisodeNo - 1);
        const levelNo = pseudo.random(0, Level.LEVELS_PER_EPISODE - 1);
        number = episodeNo * Level.LEVELS_PER_EPISODE + levelNo;
    }

    return Level.CreateByNumber(number, { type: options.type });
};

levels.User.prototype.getCurrentLevel = function () {
    const mission = this.getFakeLevelsMission();
    if (mission) {
        return mission.logic.getCurrentLevel();
    }

    if (this.isPassedAllPhysicalLevels()) {
        return this.getRandomLevel();
    }

    return new Level(this.currentPhysicalLevel.episode, this.currentPhysicalLevel.level);
};

levels.User.prototype.onUserInfoChanged = function () {
    this.trigger("userInfoChanged");
};

levels.User.prototype.getPlayerInfo = function () {
    return {
        id: connector.player.id,
        name: cleverapps.settings.getNickname() || Messages.get("Friends.You"),
        avatar: cleverapps.settings.getAvatar(),
        firstName: connector.player.firstName,
        lastName: connector.player.lastName
    };
};

levels.User.prototype.onUserIdChanged = function (params) {
    const oldId = params.oldId;

    delete this.idfa;
    this.save(false);

    cleverapps.userIdsHistory.add(oldId);

    this.updateIDFA();
};

levels.User.prototype.getSaveInfo = function () {
    const info = cleverapps.User.prototype.getSaveInfo.call(this);
    return Object.assign(info, {
        episode: this.currentPhysicalLevel.episode,
        level: this.currentPhysicalLevel.level,
        uniqueStartEvent: this.uniqueStartEvent,
        progress: this.currentPhysicalLevel.progress
    });
};

levels.User.prototype.updateInfo = function (serverData) {
    this.firstSession = false;

    this.lastVisited = serverData.visited;

    delete serverData.source;
    delete serverData.version; // clean old data

    if (serverData.forcedVisited) {
        serverData.visited = serverData.forcedVisited;
    } else {
        delete serverData.visited;
    }

    this.currentPhysicalLevel = {
        episode: serverData.episode || 0,
        level: serverData.level || 0,
        progress: serverData.progress || 0
    };

    delete serverData.episode;
    delete serverData.level;

    const exp = serverData.exp;
    delete serverData.exp;

    ExpHelper.GetMainInstance().load(exp);

    for (const item in serverData) {
        this[item] = serverData[item];
    }

    this.migrateEpisode();

    this.save(false);

    this.updateMetrics();
    this.trigger("updateCheater");
};

levels.User.prototype.migrateEpisode = function () {
    if (cleverapps.config.name !== "woodenblock") {
        return;
    }

    // migration for woodenblock users before meta change to simple
    const totalEpisodes = this.getEpisodesAmount();
    if (this.currentPhysicalLevel.episode >= totalEpisodes) {
        const diff = this.currentPhysicalLevel.episode - totalEpisodes;
        this.currentPhysicalLevel.progress += diff * Level.LEVELS_PER_EPISODE + this.currentPhysicalLevel.level;
        this.currentPhysicalLevel.episode = totalEpisodes;
        this.currentPhysicalLevel.level = 0;
    }
};

levels.User.prototype.getInfo = function () {
    return {
        id: connector.platform.getUserID(),
        gold: this.gold,
        soft: this.soft,
        registered: this.registered,
        visited: this.visited,
        source: connector.info.source,
        channel: this.channel,
        progressCompare: this.progressCompare,
        progress: this.currentPhysicalLevel.progress,
        level: this.currentPhysicalLevel.level,
        episode: this.currentPhysicalLevel.episode,
        exp: ExpHelper.GetMainInstance().getExp(),
        cheater: this.cheater ? 1 : 0,
        version: cleverapps.config.version // need for migration from old clients on client and on server
    };
};

levels.User.prototype.getEpisodesAmount = function () {
    if (this.episodesAmount === undefined) {
        this.episodesAmount = levels.User.CalcEpisodesAmount(cleverapps.config.importMode);
    }
    return this.episodesAmount;
};

levels.User.prototype.resetEpisodesAmount = function () {
    this.episodesAmount = undefined;
};

levels.User.CalcEpisodesAndLevelsAmount = function (withDebug) {
    let amountEpisodes = 0;
    let amountLevels = 0;

    for (let cnt = 0; bundles[Level.BundleId(cnt)] !== undefined; cnt++) {
        const episodeRes = bundles[Level.BundleId(cnt)];
        if (!episodeRes.jsons || (!episodeRes.jsons.levels && !episodeRes.jsons.map_json) || (episodeRes.meta.debug && !withDebug)) {
            break;
        }

        amountEpisodes++;
        amountLevels += episodeRes.meta.levelsAmount || episodeRes.meta.episode.levelsAmount;
    }

    return {
        amountEpisodes,
        amountLevels
    };
};

levels.User.CalcEpisodesAmount = function (withDebug) {
    const res = levels.User.CalcEpisodesAndLevelsAmount(withDebug);
    return res.amountEpisodes;
};

levels.User.GOLD_FB_CONNECT_REWARD = 100;
